import React from "react";
import "./App.css";
import "./index.css";
import "./components/common_components/common_css/common_css.css";

import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Login from "./components/login/Login";
import Manage_My_Points from "./components/main_dashboard/manage_my_points/Manage_My_Points";
import Change_Password from "./components/main_dashboard/change_password/Change_Password";
import Change_Pin from "./components/main_dashboard/change_pin/Change_Pin";
import Update_Profile from "./components/main_dashboard/update_profile/Update_Profile";
import Child_Registration from "./components/main_dashboard/child_registration/Child_Registration";
import Draw_Details from "./components/main_dashboard/draw_details/Draw_Details";
import Change_Pin_Password from "./components/main_dashboard/change_pin_password/Change_Pin_Password";

function App() {

  const location = useLocation();

  return (
    <>
      {/* <ScrollToTop /> */}

      {location.pathname !== "/" && <Header />}

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/manage-my-points" element={<Manage_My_Points />} />
        <Route path="/change-password" element={<Change_Password />} />
        <Route path="/change-pin" element={<Change_Pin />} />
        <Route path="/update-profile" element={<Update_Profile />} />
        <Route path="/child-registration" element={<Child_Registration />} />
        <Route path="/draw-details" element={<Draw_Details />} />
        <Route path="/change-pin-password" element={<Change_Pin_Password />} />
        
      </Routes>
      {/* <Footer /> */}
    </>
  );
}

export default App;
